import { type ReactNode, useEffect } from "react";
import { Link } from "react-router-dom";
import { SOCLOSE } from "../../constants/soclose";
import { useT } from "../../i18n";

// Shared shell for legal pages. Each page wraps its content in <LegalLayout title=... updatedAt=...>.
export function LegalLayout({ title, updatedAt, children }: { title: string; updatedAt?: string; children: ReactNode }) {
  const tr = useT();
  useEffect(() => { document.title = `${title} -- 3DPrintForge`; }, [title]);
  return (
    <main className="legal">
      <div className="legal-in">
        <Link to="/" className="legal-back">&larr; {tr("Retour à l'accueil")}</Link>
        <h1>{title}</h1>
        <div className="legal-meta">{SOCLOSE.name} -- {SOCLOSE.uenLabel}</div>
        {updatedAt && <div className="legal-updated">{tr("Dernière mise à jour :")} {updatedAt}</div>}
        <div className="legal-prose">{children}</div>
        <div className="legal-foot">
          {tr("Pour toute question de protection des données ou question légale, contactez")}{" "}
          <a href={`mailto:${SOCLOSE.contact.email}`}>{SOCLOSE.contact.email}</a>.
        </div>
      </div>
    </main>
  );
}
